import { Injectable } from '@angular/core';
import { ExtractionTrainingData } from './model';
import { Observable } from 'rxjs';
import { ApiService } from '@ps-gui/shared-core';
import { mapTrainingData } from './training-data-mapper';

@Injectable({ providedIn: 'root' })
export class TrainingApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  submitTrainingData(data: ExtractionTrainingData): Observable<void> {
    data = mapTrainingData(data);
    return this.post(`api/batch/training/extraction`, data);
  }
}
